import type { Board } from './black_hole_game';
import { ruleHint } from './progressiveHints';
import type { HintStage } from './progressiveHints';

export default function HintPanel({ board, stage, onStage, pending, bestCell, available = true, error }: {
    board: Board; stage: HintStage; onStage: (stage: HintStage) => void;
    pending: boolean; bestCell?: string; available?: boolean; error?: string;
}) {
    if (stage === 0 || board.isGameOver()) return null;
    const complete = !!bestCell;
    return <aside className="progressive-hint" aria-label="Practice hint">
        <p className="eyebrow">{stage === 1 ? 'A place to start' : stage === 2 ? 'One move to consider' : 'Compare every ending'}</p>
        <div role="status" aria-live="polite">
            {stage === 1 ? <p>{ruleHint(board)}</p> : !available ? <p>Exact hints return on your turn. You can still use the rule tip.</p>
                : error ? <p>Couldn’t check this position. {error} Return to the tip and try again.</p>
                    : pending ? <p>Checking every legal move. You can keep playing while it works.</p>
                        : !complete ? <p>A complete exact comparison is unavailable here. Try again later in the game, or keep using the rule tip.</p>
                            : stage === 2 ? <p>The gold ring marks one best move, verified against every legal alternative. There may be other moves that do just as well.</p>
                                : <p>W: win · D: draw · L: loss, with perfect play from here. The number is your final point margin; higher is better.</p>}
        </div>
        <div className="hint-panel-actions">
            {stage === 1 && <button className="secondary" disabled={!available} onClick={() => onStage(2)}>Show one best move</button>}
            {stage === 2 && complete && available && <button className="secondary" onClick={() => onStage(3)}>Compare all moves</button>}
            {stage > 1 && <button className="text-button" onClick={() => onStage(1)}>Back to rule tip</button>}
            <button className="text-button" onClick={() => onStage(0)}>Hide hint</button>
        </div>
    </aside>;
}
